import { CollectionPageConfig, useConfig } from "../config";

import { 
  Col1Row3Span3,
  Col1Row10Span3,
  Col2Row3Span2RowsSpan2Cols,
  Col1Row9Span1RowsSpan1Cols,
  Col3Row3Span3,
  Col1Row8Span2,
  Col3Row13Span1,
  Col1Row4Span2RowsSpan2Cols,
  Col2Row13Span1RowSpan2Cols,
  Col1Row3Span1RowSpan1Col,
  Col1Row13Span1RowSpan1Col,
  Col1Row3Span1RowSpan2Cols,
  Col3Row7Span2RowsSpan1Col,
  Col1Row13Span1RowSpan2Cols,
  Col1Row11Span3RowsSpan1Col,
} from "../components/PromoBox";

export default function PromoComponent({ itemsLength, hitsPerPage }: { itemsLength: number; hitsPerPage: number }) {
  const { collectionTemplate, promoData } = useConfig() as CollectionPageConfig;

  if (!collectionTemplate || !promoData) return null; // If no template or promoData, render nothing.

  const templateComponents: Record<
    string,
    (promoData: CollectionPageConfig["promoData"]) => JSX.Element | null
  > = {
    Combo1: (promoData) =>
      itemsLength >= hitsPerPage ? (
        <>
          {promoData?.first && (
            <Col1Row3Span3
              heading={promoData.first.heading}
              imgSrc={promoData.first.image.image_1x3}
              imgSrcMobile={promoData.first.image.image_1x3}
              imgSrcTablet={promoData.first.image.image_1x2}
              imgSrcDesktop={promoData.first.image.image_1x3}
              paragraph={promoData.first.paragraph}
              linkText={promoData.first.linkText}
              linkHref={promoData.first.linkHref}
              contentPosition={promoData.first.contentPosition}
            />
          )}
          {promoData?.second && (
            <Col1Row10Span3
              heading={promoData.second.heading}
              imgSrc={promoData.second.image.image_1x1}
              imgSrcMobile={promoData.second.image.image_1x1}
              imgSrcTablet={promoData.second.image.image_1x2}
              imgSrcDesktop={promoData.second.image.image_3x1}
              paragraph={promoData?.second.paragraph}
              linkText={promoData?.second.linkText}
              linkHref={promoData?.second.linkHref}
              contentPosition={promoData.second.contentPosition}
            />
          )}
        </>
      ) : null,

    Combo2: (promoData) =>
      itemsLength >= hitsPerPage ? (
        <>
          {promoData?.first && (
            <Col2Row3Span2RowsSpan2Cols
              heading={promoData.first.heading}
              imgSrc={promoData.first.image.image_1x2}
              imgSrcMobile={promoData.first.image.image_1x2}
              imgSrcTablet={promoData.first.image.image_2x2}
              imgSrcDesktop={promoData.first.image.image_2x2}
              paragraph={promoData.first.paragraph}
              linkText={promoData.first.linkText}
              linkHref={promoData.first.linkHref}
              contentPosition={promoData.first.contentPosition}
            />
          )}
          {promoData?.second && (
            <Col1Row9Span1RowsSpan1Cols
              heading={promoData.second.heading}
              imgSrc={promoData.second.image.image_1x1}
              paragraph={promoData?.second.paragraph}
              linkText={promoData?.second.linkText}
              linkHref={promoData?.second.linkHref}
              contentPosition={promoData.second.contentPosition}
            />
          )}
        </>
      ) : null,

    Combo3: (promoData) =>
      itemsLength >= hitsPerPage ? (
        <>
          {promoData?.first && (
            <Col3Row3Span3
              heading={promoData.first.heading}
              imgSrc={promoData.first.image.image_1x2}
              imgSrcMobile={promoData.first.image.image_1x2}
              imgSrcTablet={promoData.first.image.image_1x2}
              imgSrcDesktop={promoData.first.image.image_1x3}
              paragraph={promoData.first.paragraph}
              linkText={promoData.first.linkText}
              linkHref={promoData.first.linkHref}
              contentPosition={promoData.first.contentPosition}
            />
          )}
          {promoData?.second && (
            <Col1Row8Span2
              heading={promoData.second.heading}
              imgSrc={promoData.second.image.image_1x1}
              imgSrcTablet={promoData.second.image.image_1x2}
              paragraph={promoData?.second.paragraph}
              linkText={promoData?.second.linkText}
              linkHref={promoData?.second.linkHref}
              contentPosition={promoData.second.contentPosition}
            />
          )}
          {promoData?.third && (
            <Col3Row13Span1
              heading={promoData?.third.heading}
              imgSrc={promoData.third.image.image_1x1}
              paragraph={promoData?.third.paragraph}
              linkText={promoData?.third.linkText}
              linkHref={promoData?.third.linkHref}
              contentPosition={promoData.third.contentPosition}
            />
          )}
        </>
      ) : null,

    Combo4: (promoData) =>
      itemsLength >= hitsPerPage ? (
        <>
          {promoData?.first && (
            <Col1Row4Span2RowsSpan2Cols
              heading={promoData.first.heading}
              imgSrc={promoData.first.image.image_1x2}
              imgSrcMobile={promoData.first.image.image_1x2}
              imgSrcTablet={promoData.first.image.image_2x2}
              imgSrcDesktop={promoData.first.image.image_2x2}
              paragraph={promoData.first.paragraph}
              linkText={promoData.first.linkText}
              linkHref={promoData.first.linkHref}
              contentPosition={promoData.first.contentPosition}
            />
          )}
          {promoData?.second && (
            <Col2Row13Span1RowSpan2Cols
              heading={promoData.second.heading}
              imgSrc={promoData.second.image.image_1x1}
              imgSrcTablet={promoData.second.image.image_1x2}
              paragraph={promoData?.second.paragraph}
              linkText={promoData?.second.linkText}
              linkHref={promoData?.second.linkHref}
              contentPosition={promoData.second.contentPosition}
            />
          )}
        </>
      ) : null,

    Combo5: (promoData) =>
      itemsLength >= hitsPerPage ? (
        <>
          {promoData?.first && (
            <Col1Row3Span1RowSpan1Col
              heading={promoData.first.heading}
              imgSrc={promoData.first.image.image_1x1}
              paragraph={promoData.first.paragraph}
              linkText={promoData.first.linkText}
              linkHref={promoData.first.linkHref}
              contentPosition={promoData.first.contentPosition}
            />
          )}
          {promoData?.second && (
            <Col1Row13Span1RowSpan1Col
              heading={promoData.second.heading}
              imgSrc={promoData.second.image.image_1x1}
              paragraph={promoData?.second.paragraph}
              linkText={promoData?.second.linkText}
              linkHref={promoData?.second.linkHref}
              contentPosition={promoData.second.contentPosition}
            />
          )}
        </>
      ) : null,

    Combo6: (promoData) =>
      itemsLength >= hitsPerPage ? (
        <>
          {promoData?.first && (
            <Col1Row3Span1RowSpan2Cols
              heading={promoData.first.heading}
              imgSrc={promoData.first.image.image_1x1}
              imgSrcMobile={promoData.first.image.image_1x1}
              imgSrcTablet={promoData.first.image.image_1x2}
              imgSrcDesktop={promoData.first.image.image_1x2}
              paragraph={promoData.first.paragraph}
              linkText={promoData.first.linkText}
              linkHref={promoData.first.linkHref}
              contentPosition={promoData.first.contentPosition}
            />
          )}
          {promoData?.second && (
            <Col3Row7Span2RowsSpan1Col
              heading={promoData.second.heading}
              imgSrc={promoData.second.image.image_1x1}
              imgSrcTablet={promoData.second.image.image_1x2}
              paragraph={promoData?.second.paragraph}
              linkText={promoData?.second.linkText}
              linkHref={promoData?.second.linkHref}
              contentPosition={promoData.second.contentPosition}
            />
          )}
          {promoData?.third && (
            <Col1Row13Span1RowSpan2Cols
              heading={promoData?.third.heading}
              imgSrc={promoData.third.image.image_1x1}
              imgSrcTablet={promoData.third.image.image_1x2}
              paragraph={promoData?.third.paragraph}
              linkText={promoData?.third.linkText}
              linkHref={promoData?.third.linkHref}
              contentPosition={promoData.third.contentPosition}
            />
          )}
        </>
      ) : null,

    Combo7: (promoData) =>
      itemsLength >= hitsPerPage ? (
        <>
          {promoData?.first && (
            <Col3Row3Span3
              heading={promoData.first.heading}
              imgSrc={promoData.first.image.image_1x2}
              imgSrcDesktop={promoData.first.image.image_1x3}
              paragraph={promoData.first.paragraph}
              linkText={promoData.first.linkText}
              linkHref={promoData.first.linkHref}
              contentPosition={promoData.first.contentPosition}
            />
          )}
          {promoData?.second && (
            <Col1Row11Span3RowsSpan1Col
              heading={promoData.second.heading}
              imgSrc={promoData.second.image.image_1x2}
              imgSrcDesktop={promoData.second.image.image_1x3}
              paragraph={promoData?.second.paragraph}
              linkText={promoData?.second.linkText}
              linkHref={promoData?.second.linkHref}
              contentPosition={promoData.second.contentPosition}
            />
          )}
        </>
      ) : null,
  };

  return templateComponents[collectionTemplate]?.(promoData) || null;
}